import React from 'react';
import styled from 'styled-components';

const TitleBox = (props) => {
    return (
        <>
            <Box sty={props.sty} type={props.type}>
                <img src={require("../../../style/img/square.png")} alt="네모"/>
                <p>
                    <span>{props.emphasis}</span>{props.text}
                </p>
            </Box>
        </>
    );
};

const Box = styled.div`
    display: flex;
    align-items:center;
    border-bottom: 2px solid lightgray;
    padding-bottom: 10px;
    margin-top: ${props => props.sty && props.sty};

    img {
        margin-right:6px;
    }
    p {
        font-size:21px;
        color: #262626;
        font-weight: bold;

        span {
            color: ${props => props.type === 0 ? '#ff402c' : '#0662df'};
            margin-right: 7px;
            position: relative;
            font-weight: bold;

            &::before {
                content:"";
                position:absolute;
                bottom:0;
                left:0;
                height: 50%;
                width: 106%;
                background-color: #dde9ed;
                z-index:-1;
            }
        }
    }
`;

export default TitleBox;
